import { useRef, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate, formatDateReverse } from "../../utils/Utilities.js";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./CreateEmployee.css";
import useAuth from "../../hooks/useAuth";
import TopBar from "./TopBar";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom


const UpdateEmployee = () => {
  // Initialize state for firstTabInput to store form data
  // const [firstTabInput, setFirstTabInput] = useState(""); 
  const { employeeId } = useParams(); // Get the employeeId from the URL
  const [name, setname] = useState("");
  const [employee_code, setemployee_code] = useState("");
  const [id_card_type, setid_card_type] = useState("");
  const [id_card_number, setid_card_number] = useState("");
  const [date, setdate] = useState("");
  const [state, setstate] = useState("");
  const [city, setcity] = useState("");
  const [pincode, setpincode] = useState("");
  const [address, setaddress] = useState("");
  const [mobile1, setmobile1] = useState("");
  const [mobile2, setmobile2] = useState("");
  const [email, setemail] = useState("");
  const [designation, setdesignation] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const GET_EMPLOYEE_URL = "api/get-employee";
  const [employee, setEmployee] = useState([]); // To store list of users
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);





  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        "Content-Type": "application/json",
      };
      const data = {
        // manifest_number: manifestNumber,
        employee_id: employeeId,
      };

      try {

        const response = await axiosPrivate.get(GET_EMPLOYEE_URL, {
          params: data,
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });

        setEmployee(response.data); // Store the fetched data into the user state
        setname(response.data.name);
        setemployee_code(response.data.employee_code);
        const formatDate_Reverse = formatDateReverse(response.data.date_of_join);
        setdate(formatDate_Reverse);
        setid_card_number(response.data.id_card_number)
        setid_card_type(response.data.id_card_type)
        setstate(response.data.state)
        setcity(response.data.city)
        setpincode(response.data.pincode)
        setaddress(response.data.address)
        setmobile1(response.data.mobile1)
        setmobile2(response.data.mobile2)
        setemail(response.data.email)
        setdesignation(response.data.designation)
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false); // Set loading to false even if there is an error
      }
    };


    fetchData();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }
























  // Handle form completion
  const handleComplete = async () => {
    setIsSubmitting(true);

    try {
      const formattedDate = formatDate(date);

      // Build payload dynamically
      const payload = {
        employee_id: employeeId,
        employee_code,
        name,
        mobile1,
        address,
        city,
        state,
        pincode,
        id_card_number,
        id_card_type,
        designation,
        franchise_id: auth.franchise_id,
        date_of_join: formattedDate,

        // optional fields
        ...(email?.trim() && { email: email.trim() }),
        ...(mobile2?.trim() && { mobile2: mobile2.trim() }),
      };

      const response = await axiosPrivate.post(
        UPDATE_EMPLOYEE_URL,
        JSON.stringify(payload),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("Update successful:", response.data);
      alert("Employee updated successfully!");

    } catch (error) {
      console.error("Error submitting form data:", error);
      alert("An error occurred while submitting your data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };




  // Validate first tab input
  const checkValidateTab = () => {
    if (name === "" || employee_code === "" || date === "") {
      return false;
    }
    return true; // Both fields are not empty
  };

  // Validate second tab input
  // const checkValidateTab2 = () => {
  //   if (address === "" || mobile1 === "" || email === "" || designation === "") {
  //     return false;
  //   }
  //   return true; // Both fields are not empty
  // };

  // Error messages for validation
  const errorMessages = () => {
    alert("Please fill in the required fields");
  };

  const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
  const EMAIL_REGEX =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const NAME_REGEX = /^(?!\s*$).+/;
  const UPDATE_EMPLOYEE_URL = "api/update-employee";

  return (
    <Container>
      <section className="franchbody">
        <div className="wrapper10">
          <FormWizard onComplete={handleComplete}>
            <FormWizard.TabContent title="Personal details" icon="ti-user">
              <h3>Basic Information</h3>
              {/* <p>Some content for the first tab</p> */}

              <div className=" input-boxnew">
                <Row>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="name">Name  </label>


                      <input
                        type="name"
                        className="form-control"
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                      />



                    </div>
                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="employee_code">Emp code  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={employee_code}
                        onChange={(e) => setemployee_code(e.target.value)}
                      />
                      {/* <i className="bx bxs-user"></i> */}


                    </div>
                  </Col>

                </Row>

                <Row>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="id_card_type">Id Type  </label>

                      <select className="newregselect"
                        name="id_card_type"
                        value={id_card_type}
                        onChange={(e) => setid_card_type(e.target.value)}
                      >
                        <option value="">Select Id</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Voter Id">Voter Id</option>
                        <option value="Pan Card">Pan Card</option>

                      </select>


                    </div>
                  </Col>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="id_card_number">Id Number  </label>


                      <input
                        type="text"
                        className="form-control"
                        value={id_card_number}
                        onChange={(e) => setid_card_number(e.target.value)}
                      />



                    </div>
                  </Col>
                </Row>

                <Row><Col>
                  <div className=" input-boxs">
                    <label htmlFor="date"> Join Date  </label>

                    <input
                      type="date"
                      className="form-control"
                      value={date}
                      onChange={(e) => setdate(e.target.value)}
                      style={{ fontSize: "15px" }}
                    />
                    {/* <i className="bx bxs-user"></i> */}


                  </div>
                </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="state">State  </label>

                      <select className="newregselect"
                        name="state"
                        value={state}
                        onChange={(e) => setstate(e.target.value)}
                      >
                        <option value="">Select State</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Goa">Goa</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Haryana">Haryana</option>
                        <option value="Himachal Pradesh">Himachal Pradesh</option>
                        <option value="Jharkhand">Jharkhand</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Kerala">Kerala</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Manipur">Manipur</option>
                        <option value="Meghalaya">Meghalaya</option>
                        <option value="Mizoram">Mizoram</option>
                        <option value="Nagaland">Nagaland</option>
                        <option value="Odisha">Odisha</option>
                        <option value="Punjab">Punjab</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Sikkim">Sikkim</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Telangana">Telangana</option>
                        <option value="Tripura">Tripura</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="Uttarakhand">Uttarakhand</option>
                        <option value="West Bengal">West Bengal</option>
                        <option value="Andaman and Nicobar Islands">
                          Andaman and Nicobar Islands
                        </option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Dadra and Nagar Haveli and Daman and Diu">
                          Dadra and Nagar Haveli and Daman and Diu
                        </option>
                        <option value="Lakshadweep">Lakshadweep</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Puducherry">Puducherry</option>
                      </select>


                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="city">City  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={city}
                        onChange={(e) => setcity(e.target.value)}
                      />
                      {/* <i className="bx bxs-user"></i> */}


                    </div>
                  </Col>
                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="pincode">Pincode  </label>

                      <input
                        type="text"
                        className="form-control"
                        value={pincode}
                        onChange={(e) => setpincode(e.target.value)}
                      />
                      {/* <i className="bx bxs-user"></i> */}


                    </div>
                  </Col>

                </Row>


              </div>
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Additional Info"
              icon="ti-settings"
              isValid={checkValidateTab()} // Validate based on first tab input
              validationError={errorMessages} // Show validation error if invalid
            >
              <h3>Address and Contact</h3>

              <Row>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="address">Address  </label>


                    <input
                      type="text"
                      className="form-control"
                      value={address}
                      onChange={(e) => setaddress(e.target.value)}

                    />



                  </div>
                </Col>
                <Col>


                  <div className=" input-boxs">
                    <label htmlFor="mobile1">Mobile  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={mobile1}
                      onChange={(e) => setmobile1(e.target.value)}
                    />


                  </div>
                </Col>
              </Row>

              <Row>

                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="mobile2">Mobile 2  </label>


                    <input
                      type="mobile2"
                      className="form-control"
                      value={mobile2}
                      onChange={(e) => setmobile2(e.target.value)}
                    />



                  </div>
                </Col>
                <Col>


                  <div className=" input-boxs">
                    <label htmlFor="email">Email  </label>

                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                    />
                    {/* <i className="bx bxs-user"></i> */}


                  </div>
                </Col>
              </Row>

              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="designation">Designation  </label>


                  <input
                    type="text"
                    className="form-control"
                    value={designation}
                    onChange={(e) => setdesignation(e.target.value)}
                  />



                </div>
              </Col>
                <Col></Col>
              </Row>
            </FormWizard.TabContent>



            <FormWizard.TabContent title="Last step" icon="ti-check"
              // isValid={checkValidateTab2()} // Validate based on first tab input
              validationError={errorMessages} // Show validation error if invalid
            >
              <h3>Review Details</h3>
              {/* <p>Here is a summary of your details:</p> */}

              <Row>
                <Col><p className="multip"><span className="empspan">Name :</span> {name}</p> </Col>
                <Col><p className="multip"><span className="empspan">Emp Code :</span> {employee_code}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Id Type :</span> {id_card_type}</p></Col>
                <Col><p className="multip"><span className="empspan">Id Number :</span> {id_card_number}</p> </Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Date of Join :</span> {date}</p></Col>
                <Col><p className="multip"><span className="empspan">State :</span> {state}</p> </Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">City :</span> {city}</p></Col>
                <Col><p className="multip"><span className="empspan">Pincode :</span> {pincode}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Address :</span> {address}</p></Col>
                <Col><p className="multip"><span className="empspan">Mobile 1 :</span> {mobile1}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Mobile 2 :</span> {mobile2}</p></Col>
                <Col><p className="multip"><span className="empspan">Email :</span> {email}</p></Col>

              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Designation :</span> {designation}</p></Col>
              </Row>


            </FormWizard.TabContent>
          </FormWizard>

        </div>
      </section>
      <TopBar />
    </Container>
  );
};

export default UpdateEmployee;
